import { Send } from "lucide-react";
import { useEffect, useRef, useState } from "react";

import { ChatOptionComponentProps } from "../lookup";
import { InputField } from "~/components/input/input-field";
import { useT } from "~/i18n/use-t";
import { cn } from "~/util/cn";

export const EmailInput: React.FC<ChatOptionComponentProps> = ({
  sendResponse,
}) => {
  const [message, setMessage] = useState("");
  const ref = useRef<HTMLTextAreaElement>(null);
  const t = useT();

  useEffect(() => {
    ref.current?.focus();
  }, []);

  const submit = () => {
    sendResponse({
      message,
      selection: [message],
    });
    setMessage("");
  };

  return (
    <div
      className={cn(
        "mx-auto sm:mb-4",
        "w-full bg-base-100 px-4 py-3",
        "border-x border-t border-t-neutral-200 sm:border-b",
        "rounded-t-2xl sm:rounded-b-2xl",
        "max-w-screen-sm",
        "flex flex-col items-stretch",
      )}
    >
      <InputField
        type="email"
        text={message}
        setText={setMessage}
        placeholder={t({ tx: "auth.signUp.inputs.email.placeholder" })}
        className="max-h-40 w-full resize-none appearance-none break-words bg-transparent leading-6 text-mama-default-primary caret-mama-default-primary outline-none"
        onEnterPressed={submit}
        autoFocus
      />
      <button
        title="send"
        className="btn-neutral btn-sm btn ml-auto h-10 w-12"
        onClick={submit}
        disabled={!message.length}
      >
        <Send width={24} />
      </button>
    </div>
  );
};
